import { render, staticRenderFns } from "./digital-media.vue?vue&type=template&id=92f58354&functional=true"
import script from "./digital-media.vue?vue&type=script&lang=js"
export * from "./digital-media.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports